import React from "react";
export default class Input extends React.Component {
    onChange = (e) => {
        let value = e.target.value;
        let { field, onChange } = this.props;
        onChange && onChange(field, value);
    }

    render() {
        let { label, value, field, type = "text", placeholder, validateData } = this.props;
        return (
            <div style={{ marginBottom: 20 }}>
                <div className="form-group focused">
                    <label className="form-label" htmlFor="first">{label}</label>
                    <input placeholder={placeholder || "Enter Value"} onChange={this.onChange} value={value} autoComplete={"off"} id="first" className="form-input" type={type} />
                </div>
                {validateData && validateData[field] && <ErrorText errorMessage={validateData[field]} />}
            </div>
        )
    }
}

export class Select extends React.Component {
    state = {
        inputValue: '',
        fieldActive: false
    }

    activateField = () => {
        this.setState({
            fieldActive: true
        })
    }
    disableField = (e) => {
        if (e.target.value === "") {
            this.setState({
                fieldActive: false
            })
        }
    }
    updateInputValue = (e) => {
        let value = e.target.value;
        let { field, onChange } = this.props;

        if (field === "email_address") {
            value = value.trim();
        }

        onChange && onChange(value);
        this.activateField(e);
        e.preventDefault();
    }

    onKeyPress = (e) => {
        if (e.which === 13) {
            this.props.onEnter && this.props.onEnter();
        }
    }

    componentDidMount() {
        let { value } = this.props;
        value && this.inputRef.focus();
    }
    render() {
        let { label: title, field, options, value, type = "text", validateData } = this.props;
        return (
            <div style={{ marginTop: 15 }}>
                <div className="field-group">
                    <div
                        onClick={() => {
                        }}
                        // check state the input, whether it is active then apply the class for floating label
                        className={this.state.fieldActive ? "field-active label" : "label"}
                    >
                        {title}
                    </div>
                    <select ref={_ => this.selectRef = _} style={{ backgroundColor: "white", WebkitAppearance: "none", appearance: "none" }} onChange={this.onChange} value={value} id="first" className="form-input">
                        <option value="" hidden disabled selected> Select Location</option>
                        {
                            options && options.length && options.map((value, index) => {
                                return <option key={index} value={value}>{value}</option>
                            })
                        }
                    </select>
                </div>
                {validateData && validateData[field] && <ErrorText errorMessage={validateData[field]} />}
            </div>

        );
    }
}

export class FloatingLableInput extends React.Component {
    state = {
        inputValue: '',
        fieldActive: false
    }
    activateField = () => {
        this.setState({
            fieldActive: true
        })
        this.props.onFocus && this.props.onFocus();
    }

    disableField = (e) => {
        if (e.target.value === "") {
            this.setState({
                fieldActive: false
            })
        }
        this.props.onBlur && this.props.onBlur();
    }
    updateInputValue = (e) => {
        let value = e.target.value;
        let { field, onChange, length, type } = this.props;
        if (length && value.length > 10) {
            return;
        }
        if (field === "email_address") {
            value = value.trim();
        }
        onChange && onChange(value);
        this.activateField(e);
        e.preventDefault();
    }

    onKeyPress = (e) => {
        if (e.which === 13) {
            this.props.onEnter && this.props.onEnter();
        }
    }
    componentDidMount() {
        let { value } = this.props;
        value && this.inputRef.focus();
    }
    render() {
        let { label: title, field, value, type = "text", validateData, autoFocus, editable = true } = this.props;
        let inputProps = {
            type,
            autoFocus,
            value,
            onFocus: this.activateField,
            onBlur: this.disableField,
            onChange: this.updateInputValue,
            onKeyPress: this.onKeyPress
        }
        return (
            <div style={{ marginTop: 15 }}>
                <div className="field-group">
                    <div
                        onClick={() => {
                            if (editable === false) {
                                return;
                            }
                            this.inputRef.focus();
                        }}
                        // check state the input, whether it is active then apply the class for floating label
                        className={this.state.fieldActive ? "field-active label" : "label"}
                    >
                        {title}
                    </div>
                    {
                        editable ? <input
                            ref={_ => this.inputRef = _}
                            className="floating-label1"
                            {...inputProps}

                        /> : <input
                                ref={_ => this.inputRef = _}
                                className="floating-label1"
                                {...inputProps}
                                readOnly
                            />
                    }
                </div>
                {validateData && validateData[field] && <ErrorText errorMessage={validateData[field]} />}
            </div>
        );
    }
}

export class FloatingLableTextArea extends React.Component {
    state = {
        inputValue: '',
        fieldActive: false
    }

    activateField = () => {
        this.setState({
            fieldActive: true
        })
    }
    disableField = (e) => {
        if (e.target.value === "") {
            this.setState({
                fieldActive: false
            })
        }
        let { onBlur } = this.props;
        onBlur && onBlur();
    }
    updateInputValue = (e) => {
        let value = e.target.value;
        let { field, onChange } = this.props;
        if (field === "email_address") {
            value = value.trim();
        }
        onChange && onChange(value);
        this.activateField(e);
        e.preventDefault();
    }
    onKeyPress = (e) => {
        if (e.which == 13) {
            this.props.onEnter && this.props.onEnter();
        }
    }
    componentDidMount() {
        let { value } = this.props;
        value && this.inputRef.focus();
    }
    render() {
        let { label: title, field, value, type = "text", validateData, autoFocus, editable = true } = this.props;
        let inputProps = {
            type,
            autoFocus,
            value,
            onFocus: this.activateField,
            onBlur: this.disableField,
            onChange: this.updateInputValue,
            onKeyPress: this.onKeyPress
        }
        return (
            <div style={{ marginTop: 15 }}>
                <div className="field-textarea">
                    <div
                        onClick={() => {
                            if (editable === false) {
                                return;
                            }
                            this.inputRef.focus();
                        }}
                        // check state the input, whether it is active then apply the class for floating label
                        className={this.state.fieldActive ? "field-active label" : "label"}
                    >
                        {title}
                    </div>
                    {
                        editable ? <textarea
                            ref={_ => this.inputRef = _}
                            className="floating-textarea"
                            {...inputProps}

                        /> : <textarea
                                ref={_ => this.inputRef = _}
                                className="floating-textarea"
                                {...inputProps}
                                readOnly
                            />
                    }
                </div>
                {validateData && validateData[field] && <ErrorText errorMessage={validateData[field]} />}
            </div>
        );
    }
}

export class ErrorText extends React.Component {
    render() {
        return (
            <div style={{ fontSize: 12, color: "red", marginTop: 3 }}>
                {this.props.errorMessage}
            </div>
        )
    }
}